import { Company } from './company';
import { CompanyBusinessServices } from './company-business-services';
import { MobilityProgress } from './mobility-progress';
import { ProfileCheckupCompletions } from './profile-checkup-completions';
import { ProfileMotivations } from './profile-motivations';
import { ProfileTestResults } from './profile-test-results';
import { SurveyResult } from './survey-result';
import { UserGender, UserModuleAccess, UserRole } from '../enums';

export enum JobResponsibility {
  COACH = 'Je suis coach, facilitateur ou consultant',
  DIRECTION = "Je suis responsable d'une équipe, d'un département, d'une entreprise",
  RH = 'RH : vous recrutez, formez, ou prenez soin des gens',
  OTHER = 'Rien de tout cela',
}

export type Claim<T extends object = Record<string, unknown>> = {
  sub: string;
  scope: string;
  data?: T;
};

export type User = {
  id: string;
  createdAt: string;
  firstname: string;
  lastname?: string;
  email: string;
  gender?: UserGender;
  birthYear?: string;
  postalCode?: string;
  degree?: string;
  workSituation?: string;
  morale?: string;
  businessLine?: string;
  yearsOfExperience?: string;
  numberOfEmployers?: string;
  numberOfJobs?: string;
  otherCompanyName?: string;
  phoneNumber?: string;
  knownHow?: string;
  socioProfessionalCategory?: string;
  jobResponsabilities?: JobResponsibility;
  newsletterConsent: boolean;
  isRealUser?: boolean;
  companyId?: string;
  company?: Company;
  moduleAccess: UserModuleAccess[];
  businessServiceId?: string;
  companyBusinessService?: CompanyBusinessServices;
  mobility?: MobilityProgress[];
  surveyResults?: SurveyResult[];
  profileCheckupCompletions?: ProfileCheckupCompletions[];
  profileMotivations?: ProfileMotivations[];
  profileTestResults?: ProfileTestResults[];
  roles: UserRole[];
  claim?: Claim;
  completedOnboarding?: boolean;
};
